import React from "react";

export const PageHeader: React.FC<{ title: string; subtitle?: string; actions?: React.ReactNode; testid?: string }> = ({
  title,
  subtitle,
  actions,
  testid,
}) => (
  <div className="mb-6 flex items-end justify-between" data-testid={testid}>
    <div>
      <h1 className="text-3xl font-black tracking-tighter text-slate-900">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

const groupStyles: Record<string, string> = {
  ingresos_operativos: "bg-emerald-50 text-emerald-700 border-emerald-200",
  descuentos_cargos_canal: "bg-rose-50 text-rose-700 border-rose-200",
  ingresos_no_operativos: "bg-teal-50 text-teal-700 border-teal-200",
  gastos_operativos: "bg-red-50 text-red-700 border-red-200",
  gastos_no_operativos: "bg-orange-50 text-orange-700 border-orange-200",
  deuda_financiamiento: "bg-amber-50 text-amber-700 border-amber-200",
  retiros_utilidades: "bg-violet-50 text-violet-700 border-violet-200",
  transferencias_internas: "bg-sky-50 text-sky-700 border-sky-200",
  ajustes_conciliacion: "bg-slate-100 text-slate-600 border-slate-200",
  pendientes: "bg-slate-100 text-slate-500 border-slate-300 border-dashed",
};

export const GroupBadge: React.FC<{ group: string; label: string; testid?: string }> = ({ group, label, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-medium ${
      groupStyles[group] || groupStyles.ajustes
    }`}
  >
    {label}
  </span>
);

const dot: Record<string, string> = {
  connected: "bg-emerald-500",
  disconnected: "bg-slate-300",
  cobrado: "bg-emerald-500",
  pendiente: "bg-amber-500",
  success: "bg-emerald-500",
  active: "bg-amber-500",
  paid: "bg-emerald-500",
};

export const StatusBadge: React.FC<{ status: string; label?: string; testid?: string }> = ({ status, label, testid }) => (
  <span className="inline-flex items-center gap-1.5 text-xs font-medium text-slate-600" data-testid={testid}>
    <span className={`inline-block h-1.5 w-1.5 rounded-full ${dot[status] || "bg-slate-300"}`} />
    {label || status}
  </span>
);

export const EmptyState: React.FC<{ message: string; testid?: string }> = ({ message, testid }) => (
  <div className="flex flex-col items-center justify-center gap-2 py-16 text-center" data-testid={testid}>
    <div className="text-sm text-slate-400">{message}</div>
  </div>
);
